
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { resolveReturnPath } from "../../utils/authRedirect";

const getReturnPath = (location) =>
  `${location.pathname}${location.search || ""}` || "/";

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: getReturnPath(location) }}
        replace
      />
    );
  }

  return children;
};

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: getReturnPath(location) }}
        replace
      />
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={resolveReturnPath(location.state?.from, "/")}
        replace
      />
    );
  }

  return children;
};
